import { Controller } from "stimulus";
import { isSticky, setSticky } from "../sticky_navigation";

export default class extends Controller {
  static values = { setting: String };

  connect() {
    this.element.checked = isSticky(this.settingValue);
  }

  toggle() {
    setSticky(this.settingValue, this.element.checked);
  }
}
